export default "__VITE_ASSET__265097aa__"